import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, withKeys as _withKeys, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "search-bar" }
const _hoisted_2 = { style: {"margin-top":"12px","display":"flex"} }

import { RuntimeModel } from '@kunlun/dependencies';
import { OioButton, OioCol, OioForm, OioFormItem, OioInput, OioModal, OioPagination, OioRow, OioSpin, OioTag } from '@kunlun/vue-ui-antd';
import { reactive, ref, watch } from 'vue';
import { priceTypeEnum } from '../../../../constants/enum';
import { queryAddProductList } from './servicees';

interface IProps {
  label?: string;
  model: RuntimeModel;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AddDialog',
  props: {
    label: { default: '添加' },
    model: null
  },
  emits: {
  add: (selectedRows: any[]) => true,
  ['update:visible']: (visible: boolean) => true
},
  setup(__props: any, { emit: emits }) {

const props = __props as { label: string, model: RuntimeModel }





const tableRef = ref<any>(null);
const loading = ref(false);
const visible = ref(false);

const priceTypeOptions = Object.entries(priceTypeEnum).map(([key, value]) => ({ label: value, value: key }));

const state = reactive({
  dataSource: [] as any[],
  viewTableData: [] as any[],
  pagination: {
    current: 1,
    pageSize: 15,
    total: 0
  },
  selectedRows: [] as any[],
  searchForm: {
    name: '',
    code: '',
    outCode: '',
    itemNumber: '',
    priceType: null
  }
});

const checkboxChangeEvent = () => {
  state.selectedRows = tableRef.value?.getCheckboxRecords();
};

const handleSearch = () => {
  handePaginationChange();
};

const handleReset = () => {
  Object.assign(state.searchForm, {
    name: '',
    code: '',
    outCode: '',
    itemNumber: '',
    priceType: null
  });
  Object.assign(state.pagination, {
    current: 1,
    pageSize: 15,
    total: 0
  });
  handePaginationChange();
};

const handePaginationChange = async () => {
  try {
    loading.value = true;
    const res = await queryAddProductList(
      props.model!,
      { currentPage: state.pagination.current, size: state.pagination.pageSize },
      state.searchForm
    );
    state.dataSource = res.content;
    state.pagination.total = res.totalElements;
  } catch (error) {
    console.error(error);
  } finally {
    loading.value = false;
  }
};

const handleAdd = () => {
  const arr = JSON.parse(JSON.stringify(state.selectedRows));
  arr.forEach((i) => {
    delete i.isSelected;
  });
  emits('add', arr);
  visible.value = false;
};

watch(visible, (val) => {
  if (val) {
    handePaginationChange();
  } else {
    state.selectedRows = [];
  }
});

return (_ctx: any,_cache: any) => {
  const _component_a_select = _resolveComponent("a-select")!
  const _component_vxe_column = _resolveComponent("vxe-column")!
  const _component_vxe_table = _resolveComponent("vxe-table")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(OioButton), {
      class: "oio-action-item",
      size: "small",
      type: "primary",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (visible.value = true))
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(__props.label), 1)
      ]),
      _: 1
    }),
    _createVNode(_unref(OioModal), {
      visible: visible.value,
      "onUpdate:visible": _cache[11] || (_cache[11] = ($event: any) => ((visible).value = $event)),
      title: "添加商品",
      width: "60%",
      "destroy-on-close": true
    }, {
      footer: _withCtx(() => [
        _createVNode(_unref(OioButton), {
          disabled: !state.selectedRows.length,
          type: "primary",
          onClick: handleAdd
        }, {
          default: _withCtx(() => [
            _createTextVNode("确定")
          ]),
          _: 1
        }, 8, ["disabled"]),
        _createVNode(_unref(OioButton), {
          onClick: _cache[10] || (_cache[10] = ($event: any) => (visible.value = false))
        }, {
          default: _withCtx(() => [
            _createTextVNode("取消")
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createVNode(_unref(OioSpin), { loading: loading.value }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createVNode(_unref(OioForm), {
                layout: "horizontal",
                "label-col": { style: { width: '100px' } }
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(OioRow), { gutter: 12 }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(OioCol), { span: 6 }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(OioFormItem), { label: "平台商品编码" }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(OioInput), {
                                value: state.searchForm.code,
                                "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((state.searchForm.code) = $event)),
                                allowClear: "",
                                onKeyup: _withKeys(handleSearch, ["enter"]),
                                placeholder: "请输入"
                              }, null, 8, ["value", "onKeyup"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(OioCol), { span: 6 }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(OioFormItem), { label: "ERP商品编码" }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(OioInput), {
                                value: state.searchForm.outCode,
                                "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((state.searchForm.outCode) = $event)),
                                allowClear: "",
                                onKeyup: _withKeys(handleSearch, ["enter"]),
                                placeholder: "请输入"
                              }, null, 8, ["value", "onKeyup"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(OioCol), { span: 6 }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(OioFormItem), { label: "商品名称" }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(OioInput), {
                                value: state.searchForm.name,
                                "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((state.searchForm.name) = $event)),
                                allowClear: "",
                                onKeyup: _withKeys(handleSearch, ["enter"]),
                                placeholder: "请输入"
                              }, null, 8, ["value", "onKeyup"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(OioCol), { span: 6 }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(OioFormItem), null, {
                            default: _withCtx(() => [
                              _createVNode(_unref(OioButton), {
                                type: "primary",
                                onClick: handleSearch
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("搜索")
                                ]),
                                _: 1
                              }),
                              _createVNode(_unref(OioButton), {
                                style: {"margin-left":"12px"},
                                onClick: handleReset
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("重置")
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(OioRow), { gutter: 12 }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(OioCol), { span: 6 }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(OioFormItem), { label: "货号" }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(OioInput), {
                                value: state.searchForm.itemNumber,
                                "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((state.searchForm.itemNumber) = $event)),
                                allowClear: "",
                                onKeyup: _withKeys(handleSearch, ["enter"]),
                                placeholder: "请输入"
                              }, null, 8, ["value", "onKeyup"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(OioCol), { span: 6 }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(OioFormItem), { label: "价格类型" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_select, {
                                class: "oio-select",
                                value: state.searchForm.priceType,
                                "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((state.searchForm.priceType) = $event)),
                                allowClear: "",
                                style: {"width":"100%"},
                                options: _unref(priceTypeOptions),
                                placeholder: "请选择"
                              }, null, 8, ["value", "options"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _createVNode(_component_vxe_table, {
              "header-align": "center",
              border: "",
              ref_key: "tableRef",
              ref: tableRef,
              height: "252",
              size: "mini",
              "column-config": { resizable: true },
              data: state.dataSource,
              "edit-config": { trigger: 'click', mode: 'cell' },
              "scroll-x": { enabled: false },
              "scroll-y": { enabled: true, gt: 0, oSize: 20 },
              "checkbox-config": { checkField: 'isSelected', reserve: true },
              "row-config": { keyField: 'id' },
              onCheckboxChange: _cache[6] || (_cache[6] = () => checkboxChangeEvent()),
              onCheckboxAll: _cache[7] || (_cache[7] = () => checkboxChangeEvent()),
              style: {"margin-top":"12px"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_vxe_column, {
                  type: "checkbox",
                  fixed: "left",
                  width: "50",
                  align: "center"
                }),
                _createVNode(_component_vxe_column, {
                  field: "code",
                  title: "基础商品ID"
                }),
                _createVNode(_component_vxe_column, {
                  field: "code",
                  title: "平台商品编码"
                }),
                _createVNode(_component_vxe_column, {
                  field: "outCode",
                  title: "ERP商品编码"
                }),
                _createVNode(_component_vxe_column, {
                  field: "name",
                  title: "商品名称",
                  "show-overflow": ""
                }),
                _createVNode(_component_vxe_column, {
                  field: "itemNumber",
                  title: "货号",
                  "show-overflow": ""
                }),
                _createVNode(_component_vxe_column, {
                  title: "价格类型",
                  width: "100"
                }, {
                  default: _withCtx((scope) => [
                    _createVNode(_unref(OioTag), { bordered: false }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(priceTypeEnum)[scope.row.priceType]), 1)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["data"]),
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_unref(OioPagination), {
                style: {"margin-left":"auto"},
                current: state.pagination.current,
                "onUpdate:current": _cache[8] || (_cache[8] = ($event: any) => ((state.pagination.current) = $event)),
                pageSize: state.pagination.pageSize,
                "onUpdate:pageSize": _cache[9] || (_cache[9] = ($event: any) => ((state.pagination.pageSize) = $event)),
                pageSizeOptions: [10, 15, 30, 50, 100, 200],
                "show-size-changer": "",
                total: state.pagination.total,
                "show-total": (total) => `${state.pagination.total} 条`,
                onChange: handePaginationChange,
                onShowSizeChange: handePaginationChange
              }, null, 8, ["current", "pageSize", "total", "show-total"])
            ])
          ]),
          _: 1
        }, 8, ["loading"])
      ]),
      _: 1
    }, 8, ["visible"])
  ], 64))
}
}

})